const prod = {
    Url: {
        // BASIC_API: "http://jergisint/BasicServiceApi/api/",
        BASIC_API: "https://jerbasicserviceapi.jerusalem.muni.il/api/" //out
        // BASIC_API: "https://jergisint.muni.jerusalem.muni.il/BasicServiceApi/api/", //in
        // API_URL: "https://jerbasicserviceapi.jerusalem.muni.il/api/",
    },
    Connections:
    {
        Cnn_GisYk: "cnnGisYk"
    },
    Controllers:
    {
        GetJson: "Db/ExecuteGetJSON",
        GetSelect: "Db/ExecuteSelect",
        GetScalar: "Db/ExecuteChange"
    }
};

const dev = {
    Url: {
    //   API_URL: 'http://localhost:57167/api/',
      BASIC_API: "http://localhost:44390/api/",
  
    },
    Connections:
    {
        Cnn_GisYk: "cnnGisYk"
    },
    Controllers:
    {
        GetJson: "Db/ExecuteGetJSON",
        GetSelect: "Db/ExecuteSelect",
        GetScalar: "Db/ExecuteChange"       
    }
}

export const config = process.env.NODE_ENV === 'development' ? dev : prod;